module.exports = __webpack_public_path__ + "media/shui-water.f80ad2db.mp3";